import React, { useState, useCallback } from "react";
import PropTypes from "prop-types";
import get from "lodash/get";

import { browserPropType as browserInfoShape } from "../redux/withBrowserInfo";
import LoginSignupModal from "../../components/LoginSignup/LoginSignupModal";
import { intlPropType } from "../../lib/propTypes";

const DEFAULT_ANALYTICS_LABEL = "header";

const withLoginSignupModal = (Component) => {
  const LoginSignupModalStateManager = (props) => {
    const [modalState, setModalState] = useState({
      analyticsLabel: DEFAULT_ANALYTICS_LABEL,
      header: null,
      scrollBackFn: () => {},
      isOpen: false,
    });

    const intl = get(props, "intl");

    const openModal = useCallback(
      ({ analyticsLabel, header, scrollBackFn }) => {
        setModalState({
          analyticsLabel,
          header,
          isOpen: true,
          scrollBackFn,
        });
      },
      []
    );

    const closeModal = () => {
      setModalState({ isOpen: false });
      if (modalState.scrollBackFn) {
        modalState.scrollBackFn();
      }
    };

    if (props.userInfoLoading) return null;

    return (
      <React.Fragment>
        <Component {...props} openLoginSignupModal={openModal} />
        <LoginSignupModal
          intl={intl}
          onCloseRequested={closeModal}
          {...modalState}
        />
      </React.Fragment>
    );
  };

  LoginSignupModalStateManager.propTypes = {
    intl: intlPropType.isRequired,
    browser: browserInfoShape,
    userInfo: PropTypes.shape({
      locale: PropTypes.string,
      currency: PropTypes.string,
      country: PropTypes.string,
      showMatureContent: PropTypes.bool,
      isEligibleForAutoSubscribe: PropTypes.bool,
    }),
  };

  LoginSignupModalStateManager.defaultProps = {
    userInfo: null,
    browser: null,
  };

  LoginSignupModalStateManager.displayName = Component.displayName;
  LoginSignupModalStateManager.fragment = Component.fragment;

  return LoginSignupModalStateManager;
};

export default withLoginSignupModal;
